export default "__VITE_ASSET__D7_5WjPp__"